import { render } from "./VoiceAgentCDRReport.vue?vue&type=template&id=e29b934c"
import script from "./VoiceAgentCDRReport.vue?vue&type=script&lang=js"
export * from "./VoiceAgentCDRReport.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__